// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CBHy","left":"styles_left__3YK0B"};